import { render, staticRenderFns } from "./sportRules.vue?vue&type=template&id=c1c855d6&scoped=true"
import script from "./sportRules.vue?vue&type=script&lang=js"
export * from "./sportRules.vue?vue&type=script&lang=js"
import style0 from "./sportRules.vue?vue&type=style&index=0&id=c1c855d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c855d6",
  null
  
)

export default component.exports